const POST_CHECKOUT_IMAGE_URLS = {
  receipt: 'https://s3.amazonaws.com/com.givebacks.public/images/integratedcheckout/reciept.png',
  membership:
    'https://s3.amazonaws.com/com.givebacks.public/images/integratedcheckout/membership.png',
  earnOnline:
    'https://s3.amazonaws.com/com.givebacks.public/images/integratedcheckout/earn-online.png',
  products: 'https://s3.amazonaws.com/com.givebacks.public/images/integratedcheckout/products.png',
  defaultMap:
    'https://s3.amazonaws.com/com.givebacks.public/images/integratedcheckout/default-map.png',
  emptyPta: 'https://s3.amazonaws.com/com.givebacks.public/images/integratedcheckout/empty-pta.png',
};

export { POST_CHECKOUT_IMAGE_URLS };
